import React from 'react';
import { TextField } from '@mui/material';
import { useAppSelector } from '../../../../../../app/hooks';
import { toLocalDateTimeString } from '../../../../../../utils/DateConversions';

const ClosedDateEdit: React.FC = () => {
  const { currentTicket } = useAppSelector(state => state.ticket);

  return (
    <TextField
      label="Closed Date"
      size="small"
      type="datetime-local"
      fullWidth
      value={currentTicket?.timeTracking.closedDate ? toLocalDateTimeString(currentTicket.timeTracking.closedDate) : ''}
      InputLabelProps={{ shrink: true }}
      disabled // Read-only - automatically managed by backend when ticket is closed/reopened
    />
  );
};

export default ClosedDateEdit;